import {useMemo} from 'react';

import {faGlass} from '@fortawesome/pro-solid-svg-icons';
import {FontAwesomeIcon} from '@fortawesome/react-fontawesome';
import Button from 'components/Button/Button';
import Text from 'components/Text/Text';
import BeerPriceField from 'features/beersManager/BeerPriceField/BeerPriceField';
import {createPubBeerACS} from 'features/beersManager/requestAC';
import {useBeerPrices} from 'hooks/useBeerPrices';
import {useGlobalState} from 'hooks/useGlobalState';
import {useSetGlobalState} from 'hooks/useSetGlobalState';
import {setModalAC} from 'store/modal/modalSlice';
import './CheckedBeerInfo.scss';
import {CreatePubBeerDTO} from 'typescript/dto/createPubBeerDto';
import {IBeerPriceVariant} from 'typescript/interfaces/BeerPriceVariant';

const CheckedBeerInfo = () => {
  const {checkedBeer} = useGlobalState((state) => state.beersManager);
  const managedPub = useGlobalState((state) => state.managedPub);
  const [prices, , handleUpdatePrice, handleRemovePrice] = useBeerPrices();
  const enteredPrice = useMemo(() => prices.find((price) => price.amount && price.price), [prices]);

  const dispatch = useSetGlobalState();

  const handleCancel = () => {
    dispatch(setModalAC(null));
  };

  const handleAddBeer = () => {
    if (checkedBeer && managedPub) {
      const beerId = checkedBeer.id;

      const beerPrices: IBeerPriceVariant[] = prices
        .filter((price) => price.amount && price.price)
        .map(({amount, price, currency}) => {
          const priceVariant: IBeerPriceVariant = {
            amount: +amount,
            currency: +currency,
            price: +price,
          };

          return priceVariant;
        });

      const dto: CreatePubBeerDTO = {
        beer_id: beerId,
        beer_variants_attributes: beerPrices,
      };

      dispatch(createPubBeerACS(dto));
      handleCancel();
    }
  };

  return (
    <div className="checked-beer-info">
      <div className="checked-beer-info__header">
        <div className="checked-beer-info__image">
          {!checkedBeer?.imageUrl ? (
            <div className="checked-beer-info__placeholder">
              <FontAwesomeIcon icon={faGlass} />
            </div>
          ) : (
            <img src={checkedBeer?.imageUrl} alt={`${checkedBeer.name} beer`} />
          )}
        </div>
        <Text tag="h3">
          Add <span>{checkedBeer?.name}</span> to your beer list?
        </Text>
      </div>
      <div className="checked-beer-info__fields">
        {prices.map(({id, price, currency, amount}) => (
          <BeerPriceField
            key={id}
            id={id}
            price={price}
            currency={currency}
            amount={amount}
            handleUpdatePrice={handleUpdatePrice}
            handleRemovePrice={handleRemovePrice}
          />
        ))}
      </div>
      <div className="checked-beer-info__actions">
        <Button variant="tertiary-outlined" onClick={handleCancel}>
          Cancel
        </Button>
        <Button variant="tertiary" disabled={!enteredPrice} onClick={handleAddBeer}>
          Add Beer
        </Button>
      </div>
    </div>
  );
};

export default CheckedBeerInfo;
